
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.25 4h4c.522 0 1.061.186 1.438.563s.563.915.563 1.438v1h6v2h-1v16c0 1.645-1.355 3-3 3h-12c-1.645 0-3-1.355-3-3v-16h-1v-2h6v-1c0-.522.185-1.061.563-1.438S13.729 4 14.252 4zm0 2v1h4V6h-4zm-5 3v16c0 .555.445 1 1 1h12c.555 0 1-.445 1-1V9h-14zm2 3h2v11h-2V12zm4 0h2v11h-2V12zm4 0h2v11h-2V12z"}})])
          )
        }
      }
    